import { render, staticRenderFns } from "./AddedTypeMenu.vue?vue&type=template&id=532a4c3d&scoped=true&"
import script from "./AddedTypeMenu.vue?vue&type=script&lang=js&"
export * from "./AddedTypeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a4c3d",
  null
  
)

export default component.exports